import { graphql } from "../generated";

// `percentage` is the playback progress (0–100) at the time of the tap. The
// backend stores it as an analytics column and never reads it back.
export const LIKE = graphql(`
  mutation Like($id: ID!, $percentage: Float!) {
    like(id: $id, percentage: $percentage) {
      id
      liked
      likes
    }
  }
`);
